export default __webpack_public_path__ + "static/media/Banner.4e750b2b.svg";